import ListingSection from "../ListingSection/ListingSection";
import fetchStateUniversities from "../SectionRegionElements/components/CountryStateSection/data/fetchStateUniversities";
import wrapperHOC from "@Utils/wrapperHOC";
import { useSelector, shallowEqual } from "react-redux";
import { AppState } from "@Store/index";
import useTranslationHook from "hooks/useTranslationHook";

const UniversitiesSectionWrapper = () => {
  const { t } = useTranslationHook();
  const { region, ssrUniversities } = useSelector(
    ({ searchPageData }: AppState) => ({
      region: searchPageData.region,
      ssrUniversities: searchPageData.listingData?.universities,
    }),
    shallowEqual,
  );

  return (
    <ListingSection
      title={`${t(
        "searchpage.components.sectionregionelements.components.countrystatesection.universitiessectiontitle",
      )} ${region?.name === "United Kingdom" ? "UK" : region?.name} ${t(
        "searchpage.components.sectionregionelements.components.countrystatesection.universitiessectiontitleuniversities",
      )}`}
      fetchFn={fetchStateUniversities}
      type="university"
      loadingText="Loading universities..."
      ssrData={ssrUniversities}
    />
  );
};

export default wrapperHOC(UniversitiesSectionWrapper, {
  componentName: "UniversitiesSection-SearchPage",
  showForChina: true,
});
